/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {ArmcarePlus} from '../../assets/icons/icons';
import {TableDefault} from './styles';

export default ({dataTableContent, errorData}: {dataTableContent: Array<any>; errorData: Array<string>}) => (
  <TableDefault>
    <thead>
      {/* <tr>
        <th colSpan={3} className="table-first-visible">
          Spreadsheet Information
        </th>
      </tr> */}
      <tr>
        <th className="table-left m-width-s" style={{borderTopLeftRadius: '0'}}>
          {/* <div className="th-center-y">
            <span>FIRST NAME</span>
          </div> */}
        </th>
        <th className="table-left m-width-s">LAST NAME</th>
        <th className="table-left m-width-s">EMAIL</th>
        <th className="table-left">TEAM</th>
        <th className="table-left">
          <div className="th-center-y">
            <div className="margin-x-s">
              <ArmcarePlus />
            </div>
            <span>ACTIVE</span>
          </div>
        </th>
        <th className="table-left">INACTIVE</th>
        <th className="table-left" style={{borderTopRightRadius: '8px'}}></th>
      </tr>
    </thead>
    <tbody className="table-player-exam">
      {dataTableContent.map((item, index) => (
        <TableItem key={index} item={item} />
      ))}
    </tbody>
  </TableDefault>
);

const TableItem = ({item}) => {
  return (
    <tr>
      <td className="table-left">
        <span>{item[0]}</span>
      </td>
      <td className="table-left">{item[1]}</td>
      <td className="table-left">{item[2]}</td>
      <td className="table-left">pp</td>
      <td className="table-left radio-container">rr</td>
      <td className="table-left m-width-m">sss</td>
      <td className="table-left">xx</td>
    </tr>
  );
};
